import { useState } from 'react';
import Modal from '../../components/Modal/Modal'
import Snippet from '../../components/Snippet/Snippet'

import carouselClass from '../../assets/code-snippets/carousel/carouselClass'
import { implement } from '../../assets/code-snippets/carousel/snip'
import { scssPattern, cssPattern } from '../../assets/code-snippets/carousel/styleSnip'

const Carousel = () => {

    const [toggleSnip, setToggleSnip] = useState(false)

    const [jsModal, setJsModal] = useState({
        display: !1,
        cssClass: 'fluid top0',
        scroll: !0,
        header: '<h1>Carousel Class</h1>'
    })
    const [scssModal, setScssModal] = useState({
        display: !1,
        cssClass: 'fluid top0',
        scroll: !0,
        header: '<h1>Carousel Styling Sheets</h1>'
    })

    const toggleJsModal = () => {
        setJsModal(prev => ({
            ...prev, display: !prev.display
        }))
    }
    const toggleScssModal = () => {
        setScssModal(prev => ({
            ...prev, display: !prev.display
        }))
    }
    const toggleStylesheetSnippets = () => {
        setToggleSnip(prev => !prev)
    }

    return <div className="container lg py-2" id="intro">

        <Modal structure={jsModal} onToggle={toggleJsModal}>
            <Snippet code={carouselClass} language='js' />
        </Modal>

        <Modal structure={scssModal} onToggle={toggleScssModal}>
            <button onClick={toggleStylesheetSnippets} className="btn primary lg">Switch to {toggleSnip ? 'SCSS' : 'CSS'} Snippet</button>
            {toggleSnip ? <Snippet code={cssPattern} language='css' /> : <Snippet code={scssPattern} language='scss' />}
        </Modal>


        <div className="container fluid">
            <p className="text xl"><a href="#intro" className="link">&#128279;</a> Gallery & Carousel component</p>

            <p className="text md">Carousel is implemented using <button onClick={toggleJsModal} className='btn md primary' title='CLICK ME!'><code>Carousel</code></button> class, therefore to create the carousel element is as simple as defining a HTML element having a specific id or class and then call the <code>constructCarousel</code> method of  <button onClick={toggleJsModal} className='btn md primary' title='CLICK ME!'><code>Carousel</code></button> class, this class must create the entire HTML content of the carousel & gallery elements. Also you'll need the <button onClick={toggleScssModal} className="btn md primary">style</button> file responsible for styling the carousel & gallery elements.</p>

            <p className="text lg info">Access the <code>Carousel</code> class by clicking the button above.</p>

            <span className="badge lg warning gradient">APPLICATION IN REAL ENVIRONMENT</span>
            <Snippet code={implement} language='html' />
        </div>

    </div>
}

export default Carousel